import { useEffect, useRef } from 'react';

import { isCandidateCvProcessingActive } from '../candidate-ai/candidateAiReviewState';
import { CandidateAiReviewStateType } from '../candidates/Candidates.types';

type UseStartCandidateAiRefreshForActiveProcessingProps = {
  candidateId?: string;
  enabled?: boolean;
  isAiRefreshSessionActive: boolean;
  refetchAiReviewState: () => Promise<unknown>;
  resolvedAiReviewState?: CandidateAiReviewStateType;
  startCandidateAiRefreshSession: (aiReviewState: CandidateAiReviewStateType) => void;
};

export const useStartCandidateAiRefreshForActiveProcessing = ({
  candidateId,
  enabled = true,
  isAiRefreshSessionActive,
  refetchAiReviewState,
  resolvedAiReviewState,
  startCandidateAiRefreshSession,
}: UseStartCandidateAiRefreshForActiveProcessingProps) => {
  const startedAiRefreshProcessingKeyRef = useRef<string | null>(null);

  useEffect(() => {
    startedAiRefreshProcessingKeyRef.current = null;
  }, [candidateId]);

  useEffect(() => {
    if (
      !enabled ||
      !resolvedAiReviewState ||
      resolvedAiReviewState.cvProcessing.canProcess === false ||
      isAiRefreshSessionActive ||
      !isCandidateCvProcessingActive(resolvedAiReviewState.cvProcessing.status)
    ) {
      return;
    }

    const processingKey = resolvedAiReviewState.cvProcessing.cvHash ?? 'active-processing-without-cv-hash';

    if (startedAiRefreshProcessingKeyRef.current === processingKey) {
      return;
    }

    startedAiRefreshProcessingKeyRef.current = processingKey;
    startCandidateAiRefreshSession(resolvedAiReviewState);
    void refetchAiReviewState();
  }, [enabled, isAiRefreshSessionActive, refetchAiReviewState, resolvedAiReviewState, startCandidateAiRefreshSession]);
};
